import axios from "axios";

export const getData = async (url) => {
  const config = {
    headers: {
      Authorization: `JWT ${localStorage.getItem("access")}`,
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(url, config);
    console.log(res);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};
